import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/iletisim/page.tsx");
